import {
  Scissors,
  Gem,
  ShieldCheck,
  Flower2,
  MessagesSquare,
  Sparkles,
} from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const REASONS = [
  { icon: Scissors, title: "Experienced Stylists", text: "Trained professionals who stay ahead of trends and techniques." },
  { icon: Gem, title: "Premium Beauty Products", text: "Only trusted, salon-grade ranges touch your hair and skin." },
  { icon: ShieldCheck, title: "Hygienic Environment", text: "Sanitised tools, fresh linen and spotless stations — every single time." },
  { icon: Flower2, title: "Relaxing Ambience", text: "Soft light, calm music and spaces designed to help you unwind." },
  { icon: MessagesSquare, title: "Personalised Consultation", text: "We listen first, then recommend what's genuinely right for you." },
  { icon: Sparkles, title: "Wide Range of Services", text: "Hair, skin, nails, bridal and spa — everything under one elegant roof." },
];

export const WhyUs = () => {
  return (
    <section data-testid="why-us-section" className="py-24 sm:py-32 bg-brand-sand">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <Overline>Why Choose Us</Overline>
          <h2 className="mt-4 font-serif text-4xl sm:text-5xl font-bold text-brand-ink tracking-tight leading-tight">
            The little things,
            <span className="italic text-brand-green"> done beautifully.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {REASONS.map(({ icon: Icon, title, text }, i) => (
            <Reveal key={title} delay={(i % 3) * 0.08}>
              <div
                data-testid={`why-card-${i}`}
                className="group bg-white rounded-3xl p-8 shadow-soft h-full transition-all duration-500 hover:-translate-y-1.5 hover:shadow-lift"
              >
                <span className="w-14 h-14 rounded-2xl bg-brand-green/5 border border-brand-green/10 flex items-center justify-center transition-colors duration-500 group-hover:bg-brand-green">
                  <Icon
                    size={24}
                    className="text-brand-green transition-colors duration-500 group-hover:text-brand-goldlight"
                    aria-hidden="true"
                  />
                </span>
                <h3 className="mt-6 font-serif text-xl sm:text-2xl font-semibold text-brand-ink">
                  {title}
                </h3>
                <p className="mt-3 text-brand-mute text-sm sm:text-base leading-relaxed">
                  {text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
